import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router';
import classnames from 'classnames';

type ContainerProps = Readonly<
	PropsWithChildren & {
		className?: string;
	}
>;

export function Container(props: ContainerProps) {
	const isAdmin = useLocation().pathname.startsWith('/admin');
	const cn = classnames({ 'container-fluid': isAdmin, container: !isAdmin }, props.className);
	return <div className={cn}>{props.children}</div>;
}
